"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFilterEnum = void 0;
var ActivityFilterEnum;
(function (ActivityFilterEnum) {
    ActivityFilterEnum["ALL"] = "all";
    ActivityFilterEnum["UNREAD"] = "unread";
})(ActivityFilterEnum || (exports.ActivityFilterEnum = ActivityFilterEnum = {}));
